import chat from "./chat.jsx";
import menu from "./menu.jsx";

export default { chat, menu };
